import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center pt-3" }
const _hoisted_2 = {
  key: 0,
  class: "row mr-3 ml-3 pl-5 pt-2 pb-1 v-theme--light"
}
const _hoisted_3 = { class: "row mr-3 ml-3 pl-5 pt-2 v-theme--light" }
const _hoisted_4 = { class: "mr-3 ml-3 pl-5 pt-2 pb-1 v-theme--light selected-ids" }
const _hoisted_5 = { class: "selected-ids-label" }
const _hoisted_6 = {
  key: 2,
  class: "mr-3 ml-3 pl-5 pt-2 v-theme--light skip-notice"
}
const _hoisted_7 = { class: "mr-3 ml-3 pl-5 pt-2 v-theme--light force-warning" }
const _hoisted_8 = {
  key: 0,
  class: "mr-3 ml-3 pl-5 pt-1 v-theme--light force-warning"
}
const _hoisted_9 = { class: "d-flex justify-content-end m-3" }

import 'gitart-vue-dialog/dist/style.css'
import { GDialog } from 'gitart-vue-dialog'
import { computed } from 'vue'
import i18n from '@/lang/i18n'

// deviceIds は選択と行単位の実行で使う。categoryLabel は一括実行で使う
// force が true なら証明書を作り直すので警告を出す。skipCount と runningCount は案内用の台数

export default /*@__PURE__*/_defineComponent({
  __name: 'BulkProvisioningConfirmModal',
  props: {
    modelValue: { type: Boolean, default: false },
    deviceIds: { default: () => [] },
    categoryLabel: { default: null },
    force: { type: Boolean, default: false },
    skipCount: { default: 0 },
    runningCount: { default: 0 }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const title = computed(() => {
  const key = props.force ? 'forceTitle' : 'title'
  return i18n.global.t(`pages.gpsTrackerProvisioning.modal.${key}`)
})

const showSkipNotice = computed(() => !props.force && props.skipCount > 0)
const showRunningWarning = computed(() => props.force && props.runningCount > 0)

function updateDialog (value: boolean) {
  emit('update:modelValue', value)
}

function closeModal () {
  emit('update:modelValue', false)
}

function confirm () {
  emit('confirm')
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    "model-value": props.modelValue,
    "onUpdate:modelValue": updateDialog,
    "max-width": "34%",
    transition: "custom-from-bottom-transition"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", null, _toDisplayString(title.value), 1)
      ]),
      (props.categoryLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.bodyCategory', { category: props.categoryLabel, count: props.deviceIds.length })), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.bodySelected', { count: props.deviceIds.length })), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.targetIds')), 1),
              _createTextVNode(" " + _toDisplayString(props.deviceIds.map((id) => '#' + id).join(', ')), 1)
            ])
          ], 64)),
      (showSkipNotice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.skipNotice', { count: props.skipCount })), 1))
        : _createCommentVNode("", true),
      (props.force)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.forceWarning')), 1),
            (showRunningWarning.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.forceRunningWarning', { count: props.runningCount })), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_v_btn, {
          class: "m-1 reset-btn",
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.cancel')), 1)
          ]),
          _: 1
        }),
        (props.force)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "m-1",
              color: "red-darken-2",
              onClick: confirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.execute')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              class: "m-1 exec-btn",
              onClick: confirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.modal.execute')), 1)
              ]),
              _: 1
            }))
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})